export function sortBy(arr: Array<any>, key: string, order = "asc") {
  if (!arr) return;
  arr.sort((a, b) => {
    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
      return 0;
    }
    const varA = typeof a[key] === "string" ? a[key].toLowerCase() : a[key];
    const varB = typeof b[key] === "string" ? b[key].toLowerCase() : b[key];
    let comparison = 0;
    if (varA > varB) {
      comparison = 1;
    } else if (varA < varB) {
      comparison = -1;
    }
    return order === "desc" ? comparison * -1 : comparison;
  });
  return arr;
}

export function sortByName(arr) {
  const sorted = arr.sort(function (a, b) {
    if (a?.name?.toLowerCase() < b?.name?.toLowerCase()) {
      return -1;
    }
    if (a?.name?.toLowerCase() > b?.name?.toLowerCase()) {
      return 1;
    }
    return -1;
  });
  return sorted;
}

export function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator(order, orderBy) {
  return order === "desc"
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export function stableSort(array, comparator) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export function stableSortByDate(array) {
  const stabilizedThis = JSON.parse(JSON.stringify(array));
  stabilizedThis.sort(function (a, b) {
    return +new Date(a.start) - +new Date(b.start);
  });
  return stabilizedThis;
}

export function sortByDate(arr, key = "start", order = "asc") {
  return arr.sort(function (a: any, b: any) {
    if (order === "asc") {
      return +new Date(a[key]) - +new Date(b[key]);
    } else {
      return +new Date(b[key]) - +new Date(a[key]);
    }
  });
}
